import { useNavigate } from "react-router-dom";
import type { Anime } from "@/mocks/anime";
import { categories } from "@/mocks/anime";

const categoryMeta: Record<string, { color: string }> = {
  fairy: { color: "bg-accent-500" },
  elf: { color: "bg-secondary-500" },
  monster: { color: "bg-primary-500" },
};

export default function AnimeCard({ anime }: { anime: Anime }) {
  const navigate = useNavigate();
  const cat = categories.find((c) => c.type === anime.category);
  const meta = categoryMeta[anime.category] || categoryMeta.fairy;

  return (
    <article
      onClick={() => navigate(`/anime/${anime.id}`)}
      className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 hover:shadow-card"
    >
      <div className="relative w-full h-56 sm:h-64 overflow-hidden bg-background-100">
        <img
          src={anime.image}
          alt={`${anime.title} 妖精番剧海报`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span
          className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs text-white ${meta.color}`}
        >
          {cat?.name}
        </span>
        <span
          className={`absolute top-3 right-3 px-2.5 py-1 rounded-full text-xs font-medium ${
            anime.status === "连载中"
              ? "bg-accent-500 text-white"
              : "bg-foreground-950/60 text-white"
          }`}
        >
          {anime.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-foreground-950/70 to-transparent" />
        <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
          <span className="text-xs text-white/90 inline-flex items-center gap-1">
            <i className="ri-fire-line text-primary-300"></i>
            {anime.views} 次
          </span>
          <span className="text-sm font-semibold text-accent-300 inline-flex items-center gap-1">
            <i className="ri-star-fill"></i>
            {anime.rating.toFixed(1)}
          </span>
        </div>
      </div>

      <div className="p-4">
        <h3 className="font-medium text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
          {anime.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {anime.year} · {anime.episodes}
        </p>
        <div className="mt-3 flex items-center gap-1.5 flex-wrap">
          {anime.tags.slice(0, 3).map((t) => (
            <span
              key={t}
              className="px-2 py-0.5 rounded-md text-xs bg-background-100 text-foreground-600"
            >
              {t}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-accent-600 inline-flex items-center gap-1">
            <i className="ri-time-line"></i>
            {anime.updateInfo}
          </span>
          <span className="w-7 h-7 rounded-full bg-background-100 text-foreground-500 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </div>
      </div>
    </article>
  );
}